module.exports = __webpack_public_path__ + "fonts/Inter-100-greek-ext24.af80f40.woff2";